export default[
  {
    path: '/active-sign',
    name: 'active-sign',
    component: resolve => require(['views/active-sign'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/save-sign',
    name: 'save-sign',
    component: resolve => require(['views/save-sign'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/active-sign/active-sign-detail/:id',
    name: 'active-sign-detail',
    props: true,
    component: resolve => require(['views/active-sign-detail'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/save-sign/save-sign-detail/:id/:signId',
    name: 'save-sign-detail',
    props: true,
    component: resolve => require(['views/save-sign-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '存储报名/存储报名记录详情' }
  },
  {
    path: '/save-sign/active-sign-notes/:name/:id',
    name: 'active-sign-notes',
    props: true,
    component: resolve => require(['views/active-sign-notes'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '活动报名/活动报名记录' }
  },
  {
    path: '/active-sign/notes-detail/:id/:signId',
    name: 'notes-detail',
    props: true,
    component: resolve => require(['views/notes-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '活动报名/报名记录详情' }
  },
  {
    path: '/save-sign/save-sign-notes/:name/:id',
    name: 'save-sign-notes',
    props: true,
    component: resolve => require(['views/save-sign-notes'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '存储报名/存储报名记录' }
  },
  {
    path: '/export-history/sign',
    props: true,
    name: 'export-history-sign',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '存储报名/预约报名导出历史' }
  },
  {
    path: '/export-history/sign-of-active',
    props: true,
    name: 'export-history-sign',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '活动报名/预约报名导出历史' }
  },
  {
    path: '/export-history/sign-of-question',
    props: true,
    name: 'export-history-sign',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '调查问卷/调查问卷导出历史' }
  },
  {
    path: '/export-history/sign-of-parse',
    props: true,
    name: 'export-history-sign',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '报告预约解读/预约报名导出历史' }
  },
  {
    path: '/parse-sign',
    name: 'parse-sign',
    component: resolve => require(['views/active-sign'], resolve),
    meta: { auth: true, view: 'pc' }
  },

  {
    path: '/questionnaire-sign',
    name: 'questionnaire-sign',
    component: resolve => require(['views/active-sign'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/parse-sign/parse-sign-notes/:name/:id',
    name: 'parse-sign-notes',
    props: true,
    component: resolve => require(['views/active-sign-notes'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '报告预约解读/预约解读报名记录' }
  },
  {
    path: '/parse-sign/notes-detail/:id/:signId',
    name: 'parse-notes-detail',
    props: true,
    component: resolve => require(['views/notes-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '报告预约解读/报告预约解读详情' }
  },
  {
    path: '/save-sign/question-sign-notes/:name/:id',
    name: 'question-notes',
    props: true,
    component: resolve => require(['views/active-sign-notes'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '调查问卷/调查记录' }
  },
  {
    path: '/question-sign/notes-detail/:id/:signId',
    name: 'notes-detail',
    props: true,
    component: resolve => require(['views/notes-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '调查问卷/调查记录记录详情' }
  },
  {
    path: '/holiday-manage/sign',
    name: 'holiday-manage',
    component: resolve => require(['views/holiday-manage'], resolve),
    meta: { auth: true, view: 'pc', type: 'sign' }
  },
  {
    path: '/holiday-manage/sign/holiday-form/:isEdit/:id',
    name: 'holiday-manage-creat',
    component: resolve => require(['views/holiday-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '节假日管理/新建节假日', type: 'sign' }
  },
  {
    path: '/holiday-excel-new/sign',
    props: true,
    name: 'holiday-excel-new-sign',
    component: resolve => require(['views/holiday-excel-new'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '节假日管理/批量导入节假日', type: 'sign' }
  },
  {
    path: '/sign-notes-form/:isEdit/:id/:noteId',
    name: 'sign-notes-form',
    props: true,
    component: resolve => require(['views/sign-notes-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '活动报名/编辑报名记录' }
  },
  {
    path: '/life-experience-pavilion-invoice',
    name: 'life-experience-pavilion-invoice',
    component: resolve => require(['views/life-experience-pavilion-invoice'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/export-history/reservation-export',
    name: 'reservation-export',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '生命体验馆预约参观/生命体验馆预约参观导出历史' }
  },
  {
    path: '/export-history/reservation-invoice-export',
    name: 'reservation-invoice-export',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: ' 生命体验馆发票管理/生命体验馆预约发票导出历史' }
  },
  {
    path: '/life-experience-finance-audit',
    name: 'life-experience-finance-audit',
    component: resolve => require(['views/life-experience-finance-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  }
]
